import { CaseView } from 'app/area/case/case-view';
import { caseTranslations } from 'app/area/case/constants';
import { CaseContainerProps } from 'app/area/case/types';
import { CaseState, ViewMode } from 'app/area/case/types-store';
import * as navigate from 'app/area/shared/navigation';
import { SpinLoader } from 'app/components/spin-loader';
import { STATE } from 'app/constants';
import { safeNumericString } from 'app/infrastructure/data/sanitize';
import { containerFactory } from 'app/infrastructure/redux/index';
import { actionCreators as uiEngineActions } from 'app/infrastructure/ui/form/actions';
import { RenderMode } from 'app/types-shared';
import * as React from 'react';
import { bindActionCreators } from 'redux';
import { actionCreators } from './actions';
import { storeItemPathFromRoute } from 'app/infrastructure/store/entity-route';
import { isCaseViewModalOpen } from 'app/components/helpers';
import { Favourite } from 'app/area/favourite/favourite';

/**
 * Renders a single entity View component in read mode for a single case
 *
 * @export
 * @class CaseComponent
 * @extends {Component<CaseProps, any>}
 */
export class CaseComponent extends React.Component<
  CaseContainerProps & typeof actionCreators,
  CaseState
> {
  public static statePath: string = STATE.case;

  private actions: Object;

  public constructor(props: any) {
    super(props);

    this.actions = bindActionCreators(
      {
        ...actionCreators,
        ...uiEngineActions
      },
      props.dispatch
    );
  }

  public componentDidMount() {
    if (this.props.caseNumber) {
      this.props.loadCase(this.props.caseNumber);
    }
  }

  public componentDidUpdate(prev: CaseContainerProps) {
    const nextCaseNumber = safeNumericString(this.props.params.id);

    if (nextCaseNumber && nextCaseNumber !== prev.caseNumber) {
      this.props.loadCase(nextCaseNumber);
    }

    if (!this.props.selectedId && !this.props.fetching) {
      navigate.toStartupView();
    }
  }

  public render() {

    const caseProps = { ...this.props, actions: this.actions };

    return this.props.canRender
      ? <div>
          <CaseView {...caseProps} />
        </div>
      : this.props.fetching && <SpinLoader />;
  }
}

const selectors = {

  statePath: () => CaseComponent.statePath,

  applicationId: (state: CaseState, props: CaseContainerProps) => state.uiDefinition ? state.uiDefinition.caseTypeId : undefined,

  caseNumber: (state: CaseState, props: any) =>
    safeNumericString(props.params.id),

  entityId: (state: CaseState) => state.selectedId,

  entityStoreKey: (state: CaseState) => state.selectedId,

  canRender: (state: CaseState, props: any) => state.schema && !state.fetching,

  activeChildItem: (state: CaseState, props: CaseContainerProps) =>
    storeItemPathFromRoute(props.params, RenderMode.read, { id: state.selectedId}),

  activeSection: (_, props: CaseContainerProps) => Number(props.router.location.query.section),

  expandAll: (state: CaseState, props:any) =>
    (Object.keys(props.router.location.query) as any).includes('expandAll') ||state.viewMode === ViewMode.scroll,

  print: (_, props: CaseContainerProps) =>  (Object.keys(props.router.location.query) as any).includes('print'),

  parentRoute: (state: CaseState, props: CaseContainerProps) => isCaseViewModalOpen() && 
    storeItemPathFromRoute(props.params, RenderMode.read, { id: state.selectedId}, true),
  
  favouriteComponent: () => Favourite
};

const container = containerFactory(
  CaseComponent,
  actionCreators,
  selectors,
  caseTranslations
);

export { container as Case };
